//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/performancecenter/theaterArea";
export default {
  props: ['keyValue', 'showDialog', 'theaterId'],
  data: function data() {
    return {
      rules: {
        areaName: [{
          required: true,
          message: '请输入区域名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }]
      },
      childData: {
        areaName: '',
        remark: '',
        theaterId: ''
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {
          areaName: '',
          remark: '',
          theaterId: ''
        };
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this2.$set(_this2.childData, "theaterId", _this2.theaterId);

          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};